import { useHistory, useLocation } from "@magento/venia-ui/lib/drivers";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import Modal from "@Components/Modal";
import HeaderMyArea from "@Components/MyAccount/Header";
import { useUserContext } from "@overrides_venia/peregrine/context/user";
import img_placeholder from "@Src_main/assets/images/area-personale/icone/Pacchero.jpg";
import Image from "../Image";
import LinkBetween from "@Components/LinkBetween/LinkBetween";
import Icon from "@Components/Icon";
import { env } from "build/env";
export const HeaderTopRightActions = () => {
  const {
    isMobile
  } = useWindowSize();
  const {
    formatMessage
  } = useIntl();
  return isMobile ? null : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
    className: "uk-list"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(LinkBetween, {
    onClick: () => {
      const orderUrl = window.location.protocol + "//" + env.URL_TAKEAWAY + formatMessage({
        id: "url.key.order"
      });
      window.location.assign(orderUrl);
    },
    preventLink: true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-shipping",
    color: "white"
  }), formatMessage({
    id: "button.order"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(LinkBetween, {
    onClick: () => {
      const orderUrl = window.location.protocol + "//" + env.URL_TAKEAWAY + formatMessage({
        id: "url.key.book.a.table"
      });
      window.location.assign(orderUrl);
    },
    preventLink: true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-calendar",
    color: "white"
  }), formatMessage({
    id: "header.menu.prenota.title"
  })))));
};
export const SecondaryActionsShow = _ref => {
  var _currentUser$lsAccoun;
  let {
    classes,
    goToRegistration,
    hideLoyaltyModal
  } = _ref;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    formatMessage
  } = useIntl();
  const {
    isMobile
  } = useWindowSize();
  const history = useHistory();
  const location = useLocation();
  const [{
    isSignedIn,
    currentUser
  }] = useUserContext();
  const imageAvatar = currentUser.avatar ? currentUser.avatar.image : img_placeholder;
  const {
    store_view_code
  } = env;
  const totalPoints = ((_currentUser$lsAccoun = currentUser.lsAccount) === null || _currentUser$lsAccoun === void 0 ? void 0 : _currentUser$lsAccoun.scheme) && parseInt(currentUser.lsAccount.scheme.point_balance);
  return /*#__PURE__*/React.createElement("div", {
    className: "uk-navbar-right ".concat(isMobile ? "" : "uk-margin-right", " uk-flex-right ").concat(classes.secondaryActions, " ")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, isSignedIn ? /*#__PURE__*/React.createElement("div", {
    className: "user-box uk-flex uk-flex-middle uk-flex-row-reverse",
    onClick: () => {
      if (isMobile && !hideLoyaltyModal) setIsModalOpen(true);else history.push(formatMessage({
        id: "url.key.myaccount"
      }), {
        from: location.pathname + location.search
      });
    },
    style: {
      textAlign: "end"
    }
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "user",
    src: imageAvatar,
    height: "36",
    width: "36",
    displayPlaceholder: false,
    style: {
      borderRadius: "100%"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "name uk-text-emphasis",
    style: {
      display: "flex",
      flexDirection: "column",
      marginRight: "0.5rem",
      fontSize: "11px"
    }
  }, /*#__PURE__*/React.createElement("b", null, currentUser.firstname ? currentUser.firstname : currentUser.email.split("@").shift()), /*#__PURE__*/React.createElement("span", null, formatMessage({
    id: "seeds.points.label"
  }), ":"), /*#__PURE__*/React.createElement("span", null, totalPoints))) : /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: " ".concat(isMobile ? 'uk-text-emphasis' : '', " user-box uk-flex uk-flex-middle uk-flex-row-reverse  uk-text-right"),
    onClick: goToRegistration,
    style: {
      height: "3rem"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "image"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-person",
    color: "miscusi_red",
    isCircled: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "name",
    style: {
      marginRight: "0.5rem",
      fontSize: "11px",
      maxWidth: "4rem"
    }
  }, /*#__PURE__*/React.createElement("span", null, formatMessage({
    id: "header.login.accedi"
  })))), hideLoyaltyModal ? null : /*#__PURE__*/React.createElement(Modal, {
    id: "modal-loyalty-button",
    nameClass: "modal-loyalty-button",
    modalCloseOutside: false,
    closeButtonClass: "uk-modal-close-default",
    modalHeigthClass: "uk-height-1-2",
    modalDialogClass: "uk-border-rounded uk-overflow-hidden",
    isOpen: isModalOpen,
    onClose: () => {
      setIsModalOpen(false);
    },
    position: "uk-position-center"
  }, /*#__PURE__*/React.createElement(HeaderMyArea, {
    isOuterQR: true,
    qrSize: 170,
    setIsModalOpenProp: setIsModalOpen
  }))));
};
export default SecondaryActionsShow;